var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "information" } },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
              ]),
              _vm.navName == 1
                ? _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { path: "/customers/list" } } },
                    [_c("div", { staticClass: "div3" }, [_vm._v("我的客户")])]
                  )
                : _vm._e(),
              _vm.navName == 2
                ? _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { path: "/assign_custom" } } },
                    [_c("div", { staticClass: "div3" }, [_vm._v("分配客户")])]
                  )
                : _vm._e(),
              _vm.navName == 3
                ? _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { path: "/openCustomers" } } },
                    [_c("div", { staticClass: "div3" }, [_vm._v("公开客户")])]
                  )
                : _vm._e(),
              _vm.navName == 4
                ? _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { path: "/jcGuide" } } },
                    [_c("div", { staticClass: "div3" }, [_vm._v("健驰客户")])]
                  )
                : _vm._e(),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("客户资料")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "record" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "客户详情", name: "details" },
              }),
              _c(
                "el-tab-pane",
                { attrs: { label: "消费记录", name: "consumption" } },
                [
                  _vm.currentTab.name === "consumption"
                    ? _c("consumption", {
                        attrs: {
                          customerId: _vm.id,
                          currentTab: _vm.currentTab,
                          tableColumn: _vm.columnConsumption,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "分配记录", name: "allocation" } },
                [
                  _vm.currentTab.name === "allocation"
                    ? _c("consumption", {
                        attrs: {
                          customerId: _vm.id,
                          currentTab: _vm.currentTab,
                          tableColumn: _vm.columnAllocation,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "跟进记录", name: "followUp" } },
                [
                  _vm.currentTab.name === "followUp"
                    ? _c("consumption", {
                        attrs: {
                          customerId: _vm.id,
                          currentTab: _vm.currentTab,
                          tableColumn: _vm.columnFollowUp,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "变更记录", name: "changes" } },
                [
                  _vm.currentTab.name === "changes"
                    ? _c("consumption", {
                        attrs: {
                          customerId: _vm.id,
                          currentTab: _vm.currentTab,
                          tableColumn: _vm.columnChange,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.activeName == "details"
        ? _c("div", { staticClass: "headerbox" }, [
            _vm._m(0),
            _c("div", { staticClass: "headerbox_right" }),
          ])
        : _vm._e(),
      _vm.activeName == "details"
        ? _c("div", { staticClass: "basic" }, [
            _vm._m(1),
            _c("div", { staticClass: "basic_content" }, [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "img-box" }, [
                  _c("div", [
                    _vm.customerData.gender == 1
                      ? _c("img", {
                          attrs: {
                            alt: "",
                            src: require("../../assets/man_98.png"),
                          },
                        })
                      : _vm._e(),
                    _vm.customerData.gender == 2
                      ? _c("img", {
                          attrs: {
                            alt: "",
                            src: require("../../assets/women_98.png"),
                          },
                        })
                      : _vm._e(),
                    _vm.customerData.gender == 0 || !_vm.customerData.gender
                      ? _c("img", {
                          attrs: {
                            alt: "",
                            src: require("../../assets/unknown_98.png"),
                          },
                        })
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "text-box" }, [
                    _vm.customerData.vipName
                      ? _c("p", { staticClass: "vip-name" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.customerData.vipName)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.customerData.recommendUserName
                      ? _c("p", [
                          _vm._v(
                            "推荐人：" +
                              _vm._s(_vm.customerData.recommendUserName || "-")
                          ),
                        ])
                      : _vm._e(),
                    _vm.customerData.recommendUserPhone
                      ? _c("p", [
                          _vm._v(
                            "推荐人手机号：" +
                              _vm._s(_vm.customerData.recommendUserPhone || "-")
                          ),
                        ])
                      : _vm._e(),
                    _vm.customerData.industry
                      ? _c("p", [
                          _vm._v(
                            "行业：" + _vm._s(_vm.customerData.industry || "-")
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "basic_content_information" }, [
                  _c("div", { staticClass: "basic_content_information_name" }, [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.customerData.userName)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "basic_content_btn" },
                      [
                        _vm.parArray.indexOf("block") != -1
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  plain: "",
                                  type:
                                    _vm.customerData.blackListFlag == 1
                                      ? "info"
                                      : "primary",
                                  disabled:
                                    _vm.customerData.blackListFlag == 1
                                      ? true
                                      : false,
                                  size: "mini",
                                },
                                on: { click: _vm.handleBlock },
                              },
                              [
                                _vm.customerData.blackListFlag == 1
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../assets/icon_lahei_unclick.png"),
                                      },
                                    })
                                  : _c("img", {
                                      attrs: {
                                        src: require("../../assets/icon_lahei.png"),
                                      },
                                    }),
                                _vm._v(" 拉黑"),
                              ]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("mcAddorder") != -1 &&
                        (_vm.customerData.typeNew == "3" ||
                          _vm.isShow ||
                          _vm.userId == 1)
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-circle-plus-outline",
                                  plain: "",
                                  type: "primary",
                                  size: "mini",
                                  disabled:
                                    _vm.customerData.blackListFlag == 1
                                      ? true
                                      : false,
                                },
                                on: { click: _vm.addOrderForm },
                              },
                              [_vm._v("添单 ")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("btnEditCode") != -1
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-edit-outline",
                                  plain: "",
                                  type: "primary",
                                  size: "mini",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editInformation("编辑", "edit")
                                  },
                                },
                              },
                              [_vm._v("编辑 ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "basic_content_information_info" }, [
                    _c("ul", [
                      _c("li", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("手机号码1"),
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.phone
                                ? _vm.customerData.phone
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("手机号码2"),
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.phone2
                                ? _vm.customerData.phone2
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("微信号"),
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.wechatNo
                                ? _vm.customerData.wechatNo
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("微信号2"),
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.wechatNo2
                                ? _vm.customerData.wechatNo2
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [_vm._v("生日")]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.birthday
                                ? _vm.customerData.birthday
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [_vm._v("年龄")]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.age ? _vm.customerData.age : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [_vm._v("性别")]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.gender
                                ? _vm.customerData.gender == 1
                                  ? "男"
                                  : "女"
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [_vm._v("婚否")]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.marriage
                                ? _vm.customerData.marriage == 1
                                  ? "未婚"
                                  : "已婚"
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("身高(cm)"),
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.tall
                                ? _vm.customerData.tall
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("体重(kg)"),
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.weight
                                ? _vm.customerData.weight
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [_vm._v("地区")]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.provinceCode
                                ? _vm.customerData.provinceCode +
                                    _vm.customerData.cityCode +
                                    _vm.customerData.regionCode
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [_vm._v("余额")]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.balance
                                ? _vm.customerData.balance
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [_vm._v("积分")]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.points
                                ? _vm.customerData.points
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("详细地址"),
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.detailedAddress
                                ? _vm.customerData.detailedAddress
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("推荐下线"),
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            " 一代：" +
                              _vm._s(_vm.customerData.firstFansCount) +
                              "， 二代：" +
                              _vm._s(_vm.customerData.secondFansCount) +
                              "， 三代：" +
                              _vm._s(_vm.customerData.thirdFansCount) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("礼包推荐成功人数"),
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.customerData.giftOrderPersonCount
                                ? _vm.customerData.giftOrderPersonCount
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "basic_content_information_info_content" },
                    [
                      _c("ul", [
                        _c("li", [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("QQ号"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.customerData.qqNo
                                  ? _vm.customerData.qqNo
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("QQ号2"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.customerData.qqNo2
                                  ? _vm.customerData.qqNo2
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                        _c(
                          "li",
                          [
                            _c("span", { staticClass: "title" }, [
                              _vm._v("邮箱"),
                            ]),
                            _vm.customerData.email
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.customerData.email,
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "info",
                                        staticStyle: {
                                          overflow: "hidden",
                                          "text-overflow": "ellipsis",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.customerData.email
                                              ? _vm.customerData.email
                                              : "-"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c("span", { staticClass: "title" }, [
                              _vm._v("邮箱2"),
                            ]),
                            _vm.customerData.email2
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.customerData.email2,
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "info",
                                        staticStyle: {
                                          overflow: "hidden",
                                          "text-overflow": "ellipsis",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.customerData.email2
                                              ? _vm.customerData.email2
                                              : "-"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("li", [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("其他内容"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.customerData.otherContent
                                  ? _vm.customerData.otherContent
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("来源平台"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.customerData.platformName
                                  ? _vm.customerData.platformName
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("客户类别"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.customerData.customerCategory
                                  ? _vm.getCustomerCategoryText(
                                      _vm.customerData.customerCategory
                                    )
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("用户说明"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.customerData.userDescription
                                  ? _vm.customerData.userDescription
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("备注"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.customerData.remark
                                  ? _vm.customerData.remark
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "tagNameBox" }, [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("行为标签"),
                          ]),
                          _vm.customerData.tagName &&
                          _vm.customerData.tagName.length > 0
                            ? _c(
                                "span",
                                { staticClass: "info" },
                                _vm._l(_vm.tagNameList, function (tag, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: index,
                                      staticStyle: { "margin-right": "10px" },
                                      attrs: {
                                        type: "success",
                                        effect: "dark",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(tag) + " ")]
                                  )
                                }),
                                1
                              )
                            : _c("span", { staticClass: "info" }, [
                                _vm._v(" - "),
                              ]),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm.customerData.blackListFlag == 1
                  ? _c("div", { staticClass: "block" }, [
                      _c("img", {
                        attrs: {
                          alt: "",
                          src: require("../../assets/icon_lahei].png"),
                        },
                      }),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c("div", [
              _c(
                "div",
                { staticClass: "header" },
                [
                  _c("span", [_vm._v("近5条分配记录")]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: { click: _vm.jumpToAllocation },
                    },
                    [
                      _vm._v("查看更多"),
                      _c("i", {
                        staticClass: "el-icon-arrow-right el-icon--right",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "allocation_Box" },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "site-data-list",
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.listData },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "内容",
                          prop: "platformName ",
                          "min-width": "300",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !scope.row.customerChannelUser
                                    ? _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(scope.row.content),
                                        },
                                      })
                                    : _vm._e(),
                                  scope.row.customerChannelUser &&
                                  scope.row.content != "自动同步"
                                    ? _c("div", [
                                        _c("p", [
                                          _vm._v(
                                            " 订单号：" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .orderNo
                                              ) +
                                              " , "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                color: "red",
                                                display: "inline-block",
                                                margin: "0 10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " 订单状态：" +
                                                  _vm._s(
                                                    scope.row
                                                      .customerChannelUser
                                                      .orderStatus
                                                  ) +
                                                  " , "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            " 平台:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .platformName
                                              ) +
                                              ", 渠道:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .channelName
                                              ) +
                                              ", 客户名字:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .customerName
                                              ) +
                                              ", 电话:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .customerPhone
                                              ) +
                                              ", 入线时间:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .orderTimeStr
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            " 客户信息：" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .comment
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            " 商品：" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .prodName
                                              ) +
                                              " " +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .prodItem
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            " 商品数量：" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .prodNumber
                                              ) +
                                              " 商品价格：" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .prodPrice
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                color: "red",
                                                display: "inline-block",
                                                margin: "0 10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " 商品总价：" +
                                                  _vm._s(
                                                    scope.row
                                                      .customerChannelUser
                                                      .totalMoney
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        scope.row.customerChannelUser &&
                                        scope.row.customerChannelUser.orderNo
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "5px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "收货电话:" +
                                                    _vm._s(
                                                      scope.row
                                                        .customerChannelUser
                                                        .addressPhone
                                                        ? scope.row
                                                            .customerChannelUser
                                                            .addressPhone
                                                        : scope.row
                                                            .customerChannelUser
                                                            .customerPhone
                                                    )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("span", [
                                          _vm._v(
                                            "收货地址:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .address
                                              )
                                          ),
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "red",
                                              display: "inline-block",
                                              margin: "0 10px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " 支付状态：" +
                                                _vm._s(
                                                  scope.row.customerChannelUser
                                                    .payTypeLabbl
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            "留言：" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .customerMessage
                                              )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  scope.row.customerChannelUser &&
                                  scope.row.content == "自动同步"
                                    ? _c("div", [
                                        _c("p", [
                                          _vm._v(
                                            " 平台:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .platformName
                                              ) +
                                              ", 渠道:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .channelName
                                              ) +
                                              ", 客户名字:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .customerName
                                              ) +
                                              ", 电话:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .customerPhone
                                              ) +
                                              ", 入线时间:" +
                                              _vm._s(
                                                scope.row.customerChannelUser
                                                  .orderTimeStr
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v("详情请到“我的客户”查看详情"),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1280183214
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "类目",
                          prop: "productSecondCategoryNames",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.productSecondCategoryNames,
                                  function (category, index) {
                                    return _c("span", { key: index }, [
                                      _vm._v(" " + _vm._s(category) + " "),
                                    ])
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          2838275204
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "所属公司部门",
                          prop: "departmentName",
                          "min-width": "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "类型",
                          prop: "title",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "前归属人",
                          prop: "originalAssignorName",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.customerChannelUser
                                    ? _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.customerChannelUser
                                              .originalAssignorName
                                              ? scope.row.customerChannelUser
                                                  .originalAssignorName
                                              : "-"
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1990660507
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "当前归属人",
                          prop: "userName",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作人",
                          prop: "optionPerson",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作时间",
                          prop: "createdTime",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", "min-width": "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _vm.parArray.indexOf(
                                    "customeraddressUpdate"
                                  ) != -1 &&
                                  props.row.customerChannelUser &&
                                  props.row.content != "自动同步" &&
                                  props.row.customerChannelUser.existsOrderNo !=
                                    1 &&
                                  (props.row.isShow || _vm.userId == 1)
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.goAddOrder(props.row)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v("关联开单 "),
                                          props.row.customerChannelUser
                                            .existsAfterSale === 1
                                            ? _c(
                                                "sup",
                                                { staticClass: "hasSale" },
                                                [_vm._v("售")]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4292591009
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "10px" } },
              [
                _vm._m(2),
                _c(
                  "el-table",
                  {
                    staticClass: "site-data-list",
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.commissionStatisticsList },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "佣金总数", prop: "totalAmount" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "账号可用佣金",
                        prop: "effectiveAmount",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "冻结中", prop: "awaitAmount" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "已提现", prop: "appliedAmount" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "分享身份佣金", prop: "vipAmount" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "分享礼包佣金",
                        prop: "giftPackageAmount",
                        width: "180",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "分享复购佣金",
                        prop: "goodsAmount",
                        width: "180",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _vm._m(3),
                _c(
                  "el-table",
                  {
                    staticClass: "site-data-list",
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.customerData.customerUserList },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "所属类目",
                        prop: "categoryName",
                        width: "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "来源平台",
                        prop: "platformName ",
                        width: "120",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(scope.row.platformName))]
                            },
                          },
                        ],
                        null,
                        false,
                        1713610501
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "入线方式",
                        prop: "userDitchName",
                        width: "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "客户意向",
                        prop: "userIntentionName",
                        width: "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "客户等级",
                        prop: "userLevelName",
                        width: "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "客户类型", prop: "typeCN" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "是否首购", prop: "isFirst" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.isFirst == 1 ? "是" : "否")
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1291872267
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "所属部门", prop: "orgName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "跟进客服", prop: "customerUserName " },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(_vm._s(scope.row.customerUserName)),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3503668687
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "资源时间",
                        prop: "ditchTime",
                        width: "180",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$moment(
                                      scope.row.ditchTime
                                        ? scope.row.ditchTime
                                        : scope.row.createdTime
                                    )
                                  )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4116806552
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "创建时间",
                        prop: "createdTime",
                        width: "180",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.$moment(scope.row.createdTime))
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        873524573
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "最后编辑时间",
                        prop: "updatedTime",
                        width: "180",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.$moment(scope.row.updatedTime))
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3722369992
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _vm.parArray.indexOf("customeraddressUpdate") !=
                                -1
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addAddress(
                                              "Followup",
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("编辑 ")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        778863079
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.activeName == "details"
        ? _c(
            "div",
            { staticClass: "basic" },
            [
              _c(
                "div",
                {
                  staticClass: "header",
                  staticStyle: { "margin-bottom": "0" },
                },
                [
                  _c("h3", [_vm._v("收货地址")]),
                  _c(
                    "span",
                    [
                      _c("i", {
                        staticClass: "el-icon-circle-plus-outline",
                        staticStyle: { color: "#4168e7" },
                      }),
                      _vm.parArray.indexOf("customeraddressAdd") != -1
                        ? _c(
                            "el-button",
                            {
                              staticStyle: {
                                color: "#4168e7",
                                "padding-left": "0",
                                "margin-left": "0",
                              },
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.addAddress("Address")
                                },
                              },
                            },
                            [_vm._v("新增收货地址")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-table",
                {
                  staticClass: "site-data-list",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.siteDataList, stripe: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "收货人", prop: "userName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "手机号码", prop: "phone" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "地区", prop: "userName" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      props.row.provinceCode
                                        ? props.row.provinceCode +
                                            props.row.cityCode +
                                            props.row.regionCode
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      144567753
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "详细地址", prop: "detailedAddress" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "默认地址" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm.parArray.indexOf("customeraddressIsTop") != -1
                                ? _c("el-switch", {
                                    attrs: {
                                      "active-value": 1,
                                      "inactive-value": 0,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.defaultSite(props.row.id)
                                      },
                                    },
                                    model: {
                                      value: props.row.isDefault,
                                      callback: function ($$v) {
                                        _vm.$set(props.row, "isDefault", $$v)
                                      },
                                      expression: "props.row.isDefault",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      527152762
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm.parArray.indexOf("customeraddressUpdate") !=
                              -1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.dialogEdit(
                                            "addAddress",
                                            props.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("编辑 ")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("customeraddressDelete") !=
                              -1
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "red" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.dialogDelete(props.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("删除 ")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3680361805
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeName == "labelCrowds"
        ? _c("div", { staticClass: "inquiry" }, [
            _vm._m(4),
            _c("div", { staticClass: "center_box" }, [
              _c(
                "div",
                {
                  staticClass: "center_box_left",
                  attrs: { id: "center_box_left" },
                },
                [
                  _c("div", { staticClass: "center_box_left_title" }, [
                    _c("div", [_vm._v("添加自定义标签")]),
                    _vm.labelSatte == true
                      ? _c(
                          "div",
                          {
                            staticClass: "center_box_left_title_img",
                            on: { click: _vm.closeLable },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icon_shouqi.png"),
                                alt: "",
                              },
                            }),
                            _c("span", { staticClass: "close" }, [
                              _vm._v("收起"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm.labelSatte == false
                    ? _c(
                        "el-button",
                        {
                          staticClass: "label_btn",
                          attrs: { type: "primary" },
                          on: { click: _vm.labelAdd },
                        },
                        [_vm._v("新增自定义标签")]
                      )
                    : _vm._e(),
                  _vm.labelSatte == true
                    ? _c(
                        "div",
                        { staticClass: "treeStyle" },
                        [
                          _c("labelTree", {
                            ref: "labelTree",
                            attrs: {
                              isShowCheckbox: true,
                              typeStr: "typePage",
                            },
                            on: { selectArr: _vm.handlerLabelTree },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.labelSatte == true
                    ? _c("div", { staticClass: "center_box_left_bottom" }, [
                        _c(
                          "div",
                          { staticClass: "center_box_left_bottom_lefttitle" },
                          [
                            _vm.userId == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "center_box_left_bottom_item",
                                  },
                                  [_vm._v("没有合适的标签？")]
                                )
                              : _vm._e(),
                            _vm.userId == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "center_box_left_bottom_item",
                                    staticStyle: { cursor: "pointer" },
                                    on: { click: _vm.setUp },
                                  },
                                  [_vm._v("请前往创建")]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "center_box_left_btn" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "label_cancel",
                                on: { click: _vm.cancelTree },
                              },
                              [_vm._v("取消")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "label_new",
                                on: { click: _vm.newLable },
                              },
                              [_vm._v("新增")]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "center_box_right",
                },
                [
                  _c("div", { staticClass: "center_box_right_title" }, [
                    _vm._v("已获得标签"),
                  ]),
                  _c("div", { staticClass: "label" }, [_vm._v("标签")]),
                  _c("div", [
                    _c("div", { staticClass: "program" }, [
                      _vm._v("程序化标签："),
                    ]),
                    _vm.programmingTagTiers !== null &&
                    _vm.programmingTagTiers.length != 0
                      ? _c(
                          "div",
                          { staticStyle: { "margin-bottom": "20px" } },
                          _vm._l(
                            _vm.programmingTagTiers,
                            function (item, index) {
                              return _c(
                                "span",
                                { key: index, staticClass: "label_item" },
                                [_vm._v(_vm._s(item.tagName))]
                              )
                            }
                          ),
                          0
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              color: "#999999",
                              "padding-left": "20px",
                            },
                          },
                          [_vm._v("暂无标签")]
                        ),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "program" }, [
                      _vm._v("自定义标签："),
                    ]),
                    _vm.customTagTiers !== null &&
                    _vm.customTagTiers.length != 0
                      ? _c(
                          "div",
                          { staticClass: "tag-list" },
                          _vm._l(_vm.customTagTiers, function (item, index) {
                            return _c(
                              "el-tag",
                              {
                                key: index,
                                attrs: {
                                  closable: "",
                                  "disable-transitions": false,
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.handleTagClose(item.id)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(item.tagName) + " ")]
                            )
                          }),
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              color: "#999999",
                              "padding-left": "20px",
                            },
                          },
                          [_vm._v("暂无标签")]
                        ),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "crowds_label" }, [
                      _vm._v("人群"),
                    ]),
                    _vm.groupTiers !== null && _vm.groupTiers.length != 0
                      ? _c(
                          "div",
                          _vm._l(_vm.groupTiers, function (item, index) {
                            return _c(
                              "span",
                              { key: index, staticClass: "label_item" },
                              [_vm._v(_vm._s(item.groupTierName))]
                            )
                          }),
                          0
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              color: "#999999",
                              "padding-left": "20px",
                            },
                          },
                          [_vm._v("暂无人群")]
                        ),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "basic-dialog",
          attrs: {
            "before-close": _vm.handleClose,
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "transaction"
            ? [_c("h3", [_vm._v("transaction")])]
            : _vm._e(),
          _vm.dialog.type == "addAddress"
            ? _c(
                "div",
                { staticClass: "addAddress" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        "label-width": "80px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "收货人姓名",
                            "label-width": "100px",
                            prop: "userName",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "96%" },
                            attrs: { placeholder: "请输入收货人姓名" },
                            model: {
                              value: _vm.form.userName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "userName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.userName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "联系电话",
                            "label-width": "100px",
                            prop: "phone",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "96%" },
                            attrs: {
                              placeholder: "请输入联系电话",
                              oninput:
                                "if (value.length > 16) value = value.slice(0, 16);",
                            },
                            model: {
                              value: _vm.form.phone,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "phone",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.phone",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "收货地址",
                            "label-width": "100px",
                            prop: "addressValue",
                          },
                        },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "96%" },
                            attrs: {
                              options: _vm.addressOptions,
                              clearable: "",
                              filterable: "",
                              placeholder: "请选择收货地址",
                            },
                            on: { change: _vm.onChangeAddress },
                            model: {
                              value: _vm.form.addressValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "addressValue", $$v)
                              },
                              expression: "form.addressValue",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "详细地址",
                            "label-width": "100px",
                            prop: "detailedAddress",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "96%" },
                            attrs: { placeholder: "请输入详细地址" },
                            model: {
                              value: _vm.form.detailedAddress,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "detailedAddress",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.detailedAddress",
                            },
                          }),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "false-label": 0, "true-label": 1 },
                              model: {
                                value: _vm.form.isDefault,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isDefault", $$v)
                                },
                                expression: "form.isDefault",
                              },
                            },
                            [_vm._v("设为默认 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialog.visible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.dialogSubmit("form")
                            },
                          },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.dialog.type == "edit"
            ? [
                _c("add-customers", {
                  ref: "addCustomers",
                  attrs: {
                    clientObj: _vm.customerData,
                    dialogState: _vm.dialog.visible,
                    getDateList: _vm.getDateList,
                    type: _vm.dialog.type,
                    width: "700px",
                  },
                  on: { closeDialog: _vm.closeDialog },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type == "Followup"
            ? _c(
                "div",
                { staticClass: "Followup" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formFollowup",
                      attrs: {
                        model: _vm.formFollowup,
                        rules: _vm.rulesFollowup,
                        "label-width": "80px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "客户意向",
                            "label-width": "80px",
                            prop: "userIntention",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.dialog.type == "Followup",
                                filterable: "",
                                placeholder: "选择客户意向",
                              },
                              model: {
                                value: _vm.formFollowup.userIntention,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formFollowup,
                                    "userIntention",
                                    $$v
                                  )
                                },
                                expression: "formFollowup.userIntention",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.customer_intention,
                              function (item) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    label: item.dictName,
                                    value: item.dictId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "客户等级",
                            "label-width": "80px",
                            prop: "userIntention",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                placeholder: "选择客户等级",
                              },
                              model: {
                                value: _vm.formFollowup.userLevelName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formFollowup,
                                    "userLevelName",
                                    $$v
                                  )
                                },
                                expression: "formFollowup.userLevelName",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.customer_level,
                              function (item) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    label: item.dictName,
                                    value: item.dictId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "门店",
                            "label-width": "80px",
                            prop: "addressValue",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "20",
                              placeholder: "选择输入门店",
                            },
                            model: {
                              value: _vm.formFollowup.gateSentry,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formFollowup,
                                  "gateSentry",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formFollowup.gateSentry",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "资源时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "选择日期",
                            },
                            model: {
                              value: _vm.formFollowup.ditchTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.formFollowup, "ditchTime", $$v)
                              },
                              expression: "formFollowup.ditchTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialog.visible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.followUpSubmit("formFollowup")
                            },
                          },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c("popAddOrderTips", {
        ref: "popAddOrderTips",
        on: { toAddOrderLink: _vm.addOrderFormLink },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title_left" }),
      _vm._v(" 客户详情 "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("基本信息")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("佣金统计")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("跟进信息")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inquiry_header" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title_left" }),
        _vm._v(" 标签/人群 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }